import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import ButtonPrimary from '../Form/ButtonPrimary';
import CountdownTimer from './CountdownTimer';
import Badge from './Badge';
import { useCartContext } from '../../Contexts/CartContext';
import Modal from './Modal';
import Confirm from './Confirm';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useCartHook } from '../../Hooks/CartHook';
import { formatCartId } from '../../Utils/Formatters';
import Button from '../Form/Button';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { TbArrowBigRightFilled } from 'react-icons/tb';
import { useStoreContext } from '../../Contexts/StoreContext';
import StoreService from '../../Services/StoreService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { getWeekdayInPortuguese } from '../../Utils/Helpers';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import { useTranslation } from 'react-i18next';

interface ButtonOpenStoreCounterProps {
  label?: any;
  forceLabel?: boolean;
  proofPayment?: boolean;
  className?: string;
  showArrows?: boolean;
  inMenuFooter?: boolean;
}

const ButtonOpenStoreCounter = ({
  label,
  forceLabel=false,
  proofPayment=false,
  className,
  showArrows=true,
  inMenuFooter=false
} : ButtonOpenStoreCounterProps) => {

  const { t } = useTranslation();

  const { setShowLoginStoreCounter, generateToken, expiratedCode, setExpiratedCode, user, isAuthenticated, setShowLoginSuccessful, geolocation, geolocationIsBlocked, setGeolocationIsBlocked, setGeolocation } = useLoginContext();
  const [ timeResendCode, setTimeResendCode ] = useState('')
  const [ textCountdown, setTextCountdown ] = useState('')
  const [ textCustomer, setTextCustomer ] = useState(t('store_counter.text_enter_code_to_open'))
  const [ showConfirmNewCart, setShowConfirmNewCart ] = useState<boolean>(false)
  const { cartDisplay, cartFinished, showCartIsFinished, setShowCartIsFinished, setShowProofPayment, setCartConference, setCartDisplay } = useCartContext();
  const { setOrder } = useCheckoutContext();
  const { setMainLoading, setMainLoadingIcon, setMainLoadingTitle, setMainLoadingMessage, setWelcomeScreenRead, setMainLoadingCloseButton, setMainLoadingIconNoSearchMap, setMainLoadingIconError, isGeolocationAllowed, setIsGeolocationAllowed, setShowSearchBar } = useLayoutContext();
  const { storeIsOpen, noOpenCashier, getCashier } = useStoreHook();
  const { createCart, geolocationBlocked, getOpenedCustomerCartDiffStored } = useCartHook();
  const { setShowTableChoice, currentStore, cashier, setCashier } = useStoreContext();
  const { orderType, getOrderTypeIdByName } = useOrderTypeContext();
  const [showGeolocationPermission, setShowGeolocationPermission] = useState(false);
  const [messageStoreClosed, setMessageStoreClosed] = useState('');

  const [ useGeolocation ] = useState(false);  //! TEST

  useEffect(() => {
    if(generateToken) {
      setTimeResendCode(generateToken.genereted)
    }
  }, [generateToken])

  useEffect(() => {
    if(!cashier) {

      if (currentStore) {
        interface WorkdayEntry {
          id: number;
          store_id: number;
          service_type: number;
          weekday: number;
          operation_from: string;
          operation_to: string;
          max_orders: number | null;
          extra_tax_value: number | null;
          active: boolean;
        }

        const findNextActiveWorkday = (weekday: number): WorkdayEntry | undefined => {
          const maxRetries = 7;
          let attempts = 0;

          const recursiveSearch = (currentWeekday: number): WorkdayEntry | undefined => {
            if (attempts >= maxRetries) {
              return undefined; // Caso o limite de tentativas seja atingido, retorna undefined
            }

            attempts++;

            const nextDayOpen = Object.values(currentStore.store_workdays as Record<string, WorkdayEntry>).find(
              (entry) =>
                entry.service_type === Number(getOrderTypeIdByName(orderType)) &&
                entry.weekday === currentWeekday &&
                entry.active
            );

            if (nextDayOpen) {
              return nextDayOpen;
            } else {
              const nextWeekday = (currentWeekday + 1) % 7; //* 0 - 6
              return recursiveSearch(nextWeekday);
            }
          }
          return recursiveSearch(weekday);
        }

        const formatTime = (time: string): string => {
          return time.split(':').slice(0, 2).join(':');
        }

        const todayWeekday = new Date().getDay();
        const dayOpen = findNextActiveWorkday(todayWeekday);
        if (dayOpen && cashier) {
          const checkToday = todayWeekday === Number(dayOpen.weekday) ? t('layout.today') : getWeekdayInPortuguese(Number(dayOpen.weekday));
          setMessageStoreClosed(t('store_counter.button_open_store_counter.will_open', {date: checkToday, hour: formatTime(dayOpen.operation_from)}));
        }

      }

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashier, currentStore]);

  const onComplete = () => {
    setExpiratedCode(true);
    setTextCountdown(t('login.store_counter.code_expired'));
    setTextCustomer(t('login.store_counter.code_expired_resend'));
  }

  const handleCheckOpen = () => {
    setShowSearchBar(false);
    setWelcomeScreenRead(true);

    if (cartFinished && !showCartIsFinished && !proofPayment) { //* Exibindo comprovante de finalização da comanda
      setShowCartIsFinished(true);
      getCashier();
      return;
    }

    setMainLoading(true);
    setMainLoadingMessage(t('layout.loading_main.default_message'));
    getCashier()
      .then((resp) => {
        if(resp) {
          if (!useGeolocation) { //! TEST WITHOUT PERMISSION
            handleOpen();
            return;
          }
          if (!geolocation) { //* Verificando permissão de geolocalização
            if (geolocationIsBlocked) {
                geolocationBlocked();
            } else {
                if (isGeolocationAllowed) {
                  handleGeolocation();
                } else {
                  setShowGeolocationPermission(true);
                }
            }
          } else {
              handleGeolocation();
          }
        } else {
          setOrder(null);
          setCartConference([]);
          setCartDisplay(null);
          setCashier(null);
          noOpenCashier();
        }
      });
  }

  const handleOpen = () => {
    setShowProofPayment(false);

    if (!cashier) {
      noOpenCashier();
    } else if (storeIsOpen()) {
      if (isAuthenticated && !cartDisplay) {
        if (cartFinished) {
          handleCreate();
        } else {
          setShowConfirmNewCart(true);
          setMainLoading(false);
        }
      } else if (!isAuthenticated) {
        setMainLoading(false);
        setShowLoginStoreCounter(true);
        setWelcomeScreenRead(true);
      } else {
        setShowConfirmNewCart(false);
        createCart();
      }
    }
  }

  //* Verificando proximidade da loja para abertura da comanda
  const checkDistanceToOpen = async (latitude: number, longitude: number) => {
    setShowConfirmNewCart(false);
    try {
        const storeSevice = new StoreService(orderType);
        const payload = {
            store_id: currentStore.id,
            latitude: latitude,
            longitude: longitude,
        }
        const data = await storeSevice.distance(payload);
        if (data.success) {
          handleOpen();
        } else {
          setTimeout(() => {
            setMainLoadingIcon(false);
            setMainLoadingIconNoSearchMap(true);
            setMainLoadingIconError(false);
            setMainLoadingTitle(data.message);
            setMainLoadingMessage('');
            setMainLoadingCloseButton(true);
          }, 1000);
        }
    } catch (error) {
        console.error('Erro loadDistance:', error);
    }
  }

  const handleCreate = () => {
    setShowConfirmNewCart(false);
    setShowProofPayment(false);
    setMainLoadingCloseButton(true);
    setShowConfirmNewCart(false);
    setShowLoginSuccessful(false);
    setShowTableChoice(false);

    getOpenedCustomerCartDiffStored()
      .then(response => {
        if (!response || !response.id) {
          createCart();
        }
      })
      .catch(() => {}
    );
  }

  const handleGeolocation = async () => {

    setIsGeolocationAllowed(true);
    setMainLoading(true);
    setMainLoadingTitle(t('layout.geolocation_permission.loading'));
    setMainLoadingMessage(t('layout.loading_main.default_message'));
    setMainLoadingCloseButton(false);

    try {
        await new Promise<GeolocationPosition>((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
            setMainLoadingTitle(t('layout.geolocation_permission.loading'));
            setMainLoadingMessage(t('layout.loading_main.default_message'));
            setMainLoadingCloseButton(false);
            startCheckLocation();
          });
    } catch (error: any) {
      if (error.code === 1) { //* PERMISSION_DENIED
          setGeolocationIsBlocked(true);
          geolocationBlocked();
      } else {
        setMainLoadingIcon(false);
        setMainLoadingIconError(true);
        setMainLoadingTitle(t('layout.geolocation_permission.error_title'));
      }
    }
  }

  const startCheckLocation = () => {
    if (!navigator.geolocation) {
      setGeolocationIsBlocked(true);
      geolocationBlocked();
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setGeolocation({ latitude, longitude });
        setMainLoadingTitle(t('layout.geolocation_permission.loading_distance_to_store'));
        checkDistanceToOpen(latitude, longitude);
        setGeolocationIsBlocked(false);
        setMainLoadingCloseButton(false);
      },
      (error) => {
        if (error.code === error.TIMEOUT) {
          console.warn('');
          setMainLoadingIcon(false);
          setMainLoadingIconNoSearchMap(true);
          setMainLoadingIconError(false);
          setMainLoadingTitle(t('layout.geolocation_permission.error_off_title'));
          setMainLoadingMessage(t('layout.geolocation_permission.error_off_message'));
          setMainLoadingCloseButton(true);
        } else {
          // console.error('Erro ao obter a localização:', error);
        }
      },
      { enableHighAccuracy: true, maximumAge: 1000, timeout: 10000 }
    );
}

  return (
    <>

      {(currentStore && !cashier && !cartFinished) &&
        <ButtonPrimary onClick={() => {}} className={`w-full flex-col justify-center items-center pointer-events-none max-h-10 md:max-h-auto lg:max-w-80 ${className}`}>
            <span className='leading-4 text-sm'>{t('layout.store_closed_title')}</span>
            <span className="leading-4 text-xs font-normal">{ messageStoreClosed }</span>
        </ButtonPrimary>
      }

      {(currentStore && (cashier || cartFinished)) &&
        <>
          {(cartFinished && !showCartIsFinished && !proofPayment)
            ?
              inMenuFooter 
                ? <ButtonPrimary onClick={handleCheckOpen} className={`relative flex-col bg-shopfood-success hover:bg-shopfood-success active:bg-shopfood-success active:ring-shopfood-success ring-transparent ${className} shadow-white/50`}>
                    <div className='flex flex-col gap-2 justify-evenly text-center w-full absolute top-1.5 left-0 right-0'>
                      <div className="w-1/3 bg-white h-0.5 m-auto rounded-full" />
                      <div className='relative flex flex-col text-center text-2xl leading-none mb-6'>
                        <div className='text-[1.7rem] font-black text-white'>{ formatCartId(cartFinished?.display_id || cartFinished?.id) }</div>
                        <div className="text-xs font-semibold leading-none">{t('proof_payment.name')}</div>
                      </div>
                    </div>
                  </ButtonPrimary>
              : <Button onClick={handleCheckOpen} className={`py-1 w-full bg-white ring-2 ring-shopfood-success hover:bg-white active:bg-white active:ring-shopfood-success hover:ring-shopfood-success text-shopfood-title ${!showCartIsFinished && 'md:max-w-80'}`}>
                    <div className='flex gap-1 w-full items-center justify-between'>
                      <div className='flex gap-1 items-center text-xl font-black leading-5'>
                          <span>nº</span>
                          <span>{ formatCartId(cartFinished?.display_id || cartFinished?.id) }</span>
                          <Badge type="success" className='text-xs text-white ml-1.5 px-1.5 rounded-full uppercase'>{t('proof_payment.paid')}</Badge>
                      </div>
                      {label && label !== ''
                        ?
                          <div className="flex flex-col text-right pr-1 font-bold leading-none">
                              {t('proof_payment.see_your_receipt_label')}
                          </div>
                        :
                          label
                    }
                  </div>
                </Button>

            :
              <ButtonPrimary onClick={handleCheckOpen} className={`py-1 w-full justify-center leading-5 ${!showCartIsFinished && 'md:max-w-80'} ${className}`}>
                {!forceLabel && generateToken && timeResendCode
                      ?
                        <div className='flex items-center justify-between w-full text-left gap-1'>
                          <div className='grid'>
                            <span className='text-sm font-extrabold leading-4'>Olá, { user?.first_name }!</span>
                            <span className='text-xs font-normal opacity-75 leading-3'>{ textCustomer }</span>
                          </div>
                          <div className='flex items-center'>
                            <Badge type="custom" className='bg-black bg-opacity-20 rounded-full text-nowrap px-1 text-sm'>
                              {expiratedCode
                                ? textCountdown
                                : <CountdownTimer startDate={timeResendCode} durationInMinutes={3} onComplete={() => onComplete()} />}
                            </Badge>
                          </div>
                        </div>
                      : <div className='flex gap-1.5 items-center'>
                          {showArrows && <div><TbArrowBigRightFilled size={18} className='animate-side' /></div> }
                          <span className='leading-5'>{ label ? label : t('store_counter.button_open_label')}</span>
                          {showArrows && <div className='rotate-180'><TbArrowBigRightFilled size={18} className='animate-side' /></div>}
                        </div>
                  }
              </ButtonPrimary>
          }

          <Modal open={showConfirmNewCart} className="max-w-sm m-4" onClose={() => setShowConfirmNewCart(false)}>
            <Confirm
              title={t('login.store_counter.confirm_open_new_comanda_title')}
              labelConfirm={t('login.store_counter.confirm_open_new_comanda_label')}
              onConfirm={() => {
                setMainLoading(false);
                handleCreate();
              }}
              onCancel={() => {
                setShowConfirmNewCart(false);
                setMainLoading(false);
              }}
            />
          </Modal>

          <Modal open={showGeolocationPermission} className="max-w-md m-4" onClose={() => setShowGeolocationPermission(false)}>
            <Confirm
              onConfirm={() => {
                setShowGeolocationPermission(false);
                handleGeolocation();
              }}
              onCancel={() => {
                  setShowGeolocationPermission(false);
                  setMainLoading(false);
                }
              }
              title={geolocationIsBlocked ? t('layout.geolocation_permission.denied.title') : t('layout.geolocation_permission.title')}
              message={geolocationIsBlocked
                          ? t('layout.geolocation_permission.denied.message_to_open_comanda')
                          : t('layout.geolocation_permission.denied.message_to_open_comanda_message')
                        }
              labelConfirm={t('layout.geolocation_permission.denied.label_close_button')}
              labelCancel={t('layout.geolocation_permission.denied.label_cancel_button')}
            />
          </Modal>
        </>
        }
    </>
  )
}

export default ButtonOpenStoreCounter;